import { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { checkSession } from "./api";
import type { AppUser } from "./types";
import { Layout } from "./components/Layout";
import { LoginPage } from "./components/LoginPage";
import { Dashboard } from "./components/Dashboard";
import { Members } from "./components/Members";
import { MemberDetail } from "./components/MemberDetail";
import { CheckIns } from "./components/CheckIns";
import { Analytics } from "./components/Analytics";
import { SettingsPage } from "./components/Settings";
import { Chat } from "./components/Chat";

function AuthGate({ children, requiredRole }: { children: React.ReactNode; requiredRole?: string }) {
  const [user, setUser] = useState<AppUser | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkSession().then((u) => {
      setUser(u);
      setLoading(false);
    });
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="animate-spin rounded-full h-8 w-8 border-2 border-[#5f1b2c] border-t-transparent" />
      </div>
    );
  }

  if (!user) return <LoginPage onLogin={() => window.location.reload()} />;
  if (requiredRole && user.role !== requiredRole) return <Navigate to="/" replace />;

  return <>{children}</>;
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage onLogin={() => window.location.href = "/"} />} />
        <Route path="/*" element={
          <AuthGate>
            <Layout>
              <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="/members" element={<Members />} />
                <Route path="/members/:id" element={<MemberDetail />} />
                <Route path="/checkins" element={<CheckIns />} />
                <Route path="/analytics" element={<Analytics />} />
                <Route path="/chat" element={<Chat />} />
                <Route path="/settings" element={<AuthGate requiredRole="Owner"><SettingsPage /></AuthGate>} />
              </Routes>
            </Layout>
          </AuthGate>
        } />
      </Routes>
    </BrowserRouter>
  );
}